// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { PlanPackageTakeoffsV2_AiProposalFragmentDoc } from '../TakeoffsTab.generated';
import { PlanPackageAiProposalSummaryFragmentDoc } from '../../planPackageAiProposalSummary.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CreatePlanPackageAiProposalMutationVariables = Types.Exact<{
  input: Types.CreatePlanPackageAiProposalInput;
}>;


export type CreatePlanPackageAiProposalMutation = { __typename?: 'Mutation', createPlanPackageAiProposal: { __typename?: 'PlanPackageAiProposal', id: string, status: { __typename?: 'AiProposalStatusDetail', code: Types.AiProposalStatus }, planPackage: { __typename?: 'PlanPackage', id: string, aiProposal?: { __typename?: 'PlanPackageAiProposal', id: string, progressText?: string | null | undefined, status: { __typename?: 'AiProposalStatusDetail', code: Types.AiProposalStatus } } | null | undefined } } };

export type PlanPackageAiProposalStatusQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  versionId: Types.Scalars['ID']['input'];
}>;


export type PlanPackageAiProposalStatusQuery = { __typename?: 'Query', planPackage: { __typename?: 'PlanPackage', id: string, aiProposal?: { __typename?: 'PlanPackageAiProposal', id: string, createdAt: Types.Scalars['DateTime']['input'], progressText?: string | null | undefined, status: { __typename?: 'AiProposalStatusDetail', code: Types.AiProposalStatus }, asset: { __typename?: 'Asset', id: string, fileName?: string | null | undefined, downloadUrl: string }, entityProposals: Array<{ __typename?: 'AiEntityProposal', id: string, type: { __typename?: 'AiEntityProposalTypeDetail', code: Types.AiEntityProposalType }, entityType: { __typename?: 'AiEntityProposalEntityTypeDetail', code: Types.AiEntityProposalEntityType }, fieldProposals: Array<{ __typename?: 'AiFieldProposal', id: string, fieldName: string, status: { __typename?: 'AiFieldProposalStatusDetail', code: Types.AiFieldProposalStatus } }> }> } | null | undefined } };


export const CreatePlanPackageAiProposalDocument = gql`
    mutation CreatePlanPackageAiProposal($input: CreatePlanPackageAiProposalInput!) {
  createPlanPackageAiProposal(input: $input) {
    id
    status {
      code
    }
    planPackage {
      ...PlanPackageTakeoffsV2_AiProposal
    }
  }
}
    ${PlanPackageTakeoffsV2_AiProposalFragmentDoc}`;

/**
 * __useCreatePlanPackageAiProposalMutation__
 *
 * To run a mutation, you first call `useCreatePlanPackageAiProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlanPackageAiProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlanPackageAiProposalMutation, { data, loading, error }] = useCreatePlanPackageAiProposalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlanPackageAiProposalMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePlanPackageAiProposalMutation, CreatePlanPackageAiProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePlanPackageAiProposalMutation, CreatePlanPackageAiProposalMutationVariables>(CreatePlanPackageAiProposalDocument, options);
      }
export type CreatePlanPackageAiProposalMutationHookResult = ReturnType<typeof useCreatePlanPackageAiProposalMutation>;
export type CreatePlanPackageAiProposalMutationResult = ApolloReactCommon.MutationResult<CreatePlanPackageAiProposalMutation>;
export const PlanPackageAiProposalStatusDocument = gql`
    query PlanPackageAiProposalStatus($id: ID!, $versionId: ID!) {
  planPackage(id: $id, versionId: $versionId) {
    id
    aiProposal {
      ...PlanPackageAiProposalSummary
    }
  }
}
    ${PlanPackageAiProposalSummaryFragmentDoc}`;

/**
 * __usePlanPackageAiProposalStatusQuery__
 *
 * To run a query within a React component, call `usePlanPackageAiProposalStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanPackageAiProposalStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanPackageAiProposalStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function usePlanPackageAiProposalStatusQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PlanPackageAiProposalStatusQuery, PlanPackageAiProposalStatusQueryVariables> & ({ variables: PlanPackageAiProposalStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanPackageAiProposalStatusQuery, PlanPackageAiProposalStatusQueryVariables>(PlanPackageAiProposalStatusDocument, options);
      }
export function usePlanPackageAiProposalStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanPackageAiProposalStatusQuery, PlanPackageAiProposalStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanPackageAiProposalStatusQuery, PlanPackageAiProposalStatusQueryVariables>(PlanPackageAiProposalStatusDocument, options);
        }
// @ts-ignore
export function usePlanPackageAiProposalStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageAiProposalStatusQuery, PlanPackageAiProposalStatusQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackageAiProposalStatusQuery, PlanPackageAiProposalStatusQueryVariables>;
export function usePlanPackageAiProposalStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageAiProposalStatusQuery, PlanPackageAiProposalStatusQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackageAiProposalStatusQuery | undefined, PlanPackageAiProposalStatusQueryVariables>;
export function usePlanPackageAiProposalStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageAiProposalStatusQuery, PlanPackageAiProposalStatusQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlanPackageAiProposalStatusQuery, PlanPackageAiProposalStatusQueryVariables>(PlanPackageAiProposalStatusDocument, options);
        }
export type PlanPackageAiProposalStatusQueryHookResult = ReturnType<typeof usePlanPackageAiProposalStatusQuery>;
export type PlanPackageAiProposalStatusLazyQueryHookResult = ReturnType<typeof usePlanPackageAiProposalStatusLazyQuery>;
export type PlanPackageAiProposalStatusSuspenseQueryHookResult = ReturnType<typeof usePlanPackageAiProposalStatusSuspenseQuery>;
export type PlanPackageAiProposalStatusQueryResult = ApolloReactCommon.QueryResult<PlanPackageAiProposalStatusQuery, PlanPackageAiProposalStatusQueryVariables>;